import { Component, OnDestroy, OnInit } from '@angular/core';
// import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { BlogDetailsModalComponent } from './blog-details-modal/blog-details-modal.component';
import { Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit, OnDestroy {
  language: any;
  title: string;
  details:string;
  HospitalBlogs:any[] = [];
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  Today= new Date();
  constructor(private metaTagService: Meta,private HospitalService: HospitalService,private modalService: NgbModal,
    public dialog: MatDialog,private translationService: TranslationService) { }

  ngOnInit(): void {
    this.metaTagService.updateTag({ 
      name: 'description', 
      content: 'Read our latest article on nutrition and family health, offering expert advice and tips for maintaining a healthy lifestyle.' 
    });
    this.metaTagService.updateTag({ 
      name: 'keywords', 
      content: "nutrition tips, family health, healthy lifestyle, healthcare blog" 
    });
  this.language = this.translationService.getSelectedLanguage();
   const sb = this.HospitalService.GetHospitalBlogs().subscribe(res => {
      if (res.data != null && res.isSuccess)
      {
        this.HospitalBlogs = res.data;
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;

  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  openDialog(Blog) {
    const modalRef = this.modalService.open(BlogDetailsModalComponent);
    if (this.language == 'en')
    {
      modalRef.componentInstance.data = {title: Blog.blogHeaderEn, details: Blog.blogDetailsEn , image: Blog.image}
    }
    else
    {
      modalRef.componentInstance.data = {title: Blog.blogHeaderAr, details: Blog.blogDetailsAr, image: Blog.image}
    }
   
  }
}
